import * as React from "react";
import { forwardRef } from "react";
const SvgActionChat = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 19, height: 18, viewBox: "0 0 19 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.851 13.687H5.865l1.607-1.268h4.822l2.351 1.844v-1.844h2.571V4.807h-2.571V3.538H18.5v10.149h-2.572v3.231Zm-8.779-.634v-1.9H.5V1h12.857v10.149H7.149l-3.034 2.4-1.044.832ZM1.786 9.881h2.571v1.844l2.17-1.705.18-.138h5.365V2.27H1.786Z", className: "sb6c73a54047da6201a956115d964fe5a__b" }));
const ForwardRef = forwardRef(SvgActionChat);
export { ForwardRef as ReactComponent };
